import dayjs from 'dayjs';

import { Route } from '@core/routes/Route';

export function replaceRouteParam(route: Route, routeParamKey: string, param: string | number): string {
    return route.replace(routeParamKey, String(param));
}

export function currencyFormatter(value: string) {
    if (!value) return '';

    const number = Number(value);
    const amount = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    }).format(number / 100);

    return `${amount}`;
}

export function formatDefaultDate(date?: string | null) {
    if (!date) return '';

    return dayjs(date).format('MM/DD/YY');
}

export function formatNumber(num?: number | null) {
    if (num === null || num === undefined) {
        return '';
    }

    return new Intl.NumberFormat('en-US').format(num);
}

export function formatPercentage(num?: number | null) {
    if (num === null || num === undefined) {
        return '0%';
    }

    return `${num}%`;
}

export function formatBoolean(value?: boolean | null) {
    return value ? 'Y' : 'N';
}

export function copyToClipboard(text: string) {
    const textarea = document.createElement('TEXTAREA') as HTMLTextAreaElement;
    textarea.value = text;
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);
}

export function includesInLC(string1: string, string2: string) {
    return string1.toLowerCase().includes(string2.toLowerCase());
}

export function startsFromInLC(string1: string, string2: string) {
    return string1.toLowerCase().indexOf(string2.toLowerCase()) === 0;
}

export function equalInLC(string1?: string, string2?: string) {
    if (string1 === string2) return true;
    if (!string1 || !string2) return false;
    return string1.toLowerCase() === string2.toLowerCase();
}

export function getFormattedThousand(number = 0, separator = ','): string {
    if (number < 0) return `-${getFormattedThousand(-number)}`;
    let numberString = Math.trunc(number).toString();
    let result = "";
    while (numberString.length > 3) {
        result = `${separator}${numberString.substring(numberString.length - 3)}${result}`;
        numberString = numberString.substring(0, numberString.length - 3);
    }

    result = `${numberString}${result}`;
    return result;
}